:host {
  display: flex;
  justify-content: var(--sc-upsell-countdown-timer-justify-content, center);
  align-items: var(--sc-upsell-countdown-timer-align-items, center);
  text-align: var(--sc-upsell-countdown-timer-text-align, center);
  flex-wrap: wrap;
  gap: var(--sc-upsell-countdown-timer-gap, 0.5em);
  line-height: 1;
  padding: var(--sc-upsell-countdown-timer-padding, var(--sc-spacing-medium));
  border-radius: var(--sc-upsell-countdown-timer-border-radius, var(--sc-border-radius-pill));
  background-color: var(--sc-upsell-countdown-timer-background-color, rgb(226, 249, 235));
  color: var(--sc-upsell-countdown-timer-color, rgb(71, 91, 80));
}
